import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const RequireRole = ({ allowedRoles }) => {
  const { isAuthenticated, isStaff, staffRole, loading } = useAuth();

  if (loading) {
    return <div className="p-6">Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Restaurant owners bypass staff role checks
  if (!isStaff) {
    return <Outlet />;
  }

  // Staff members must possess an allowed role
  if (allowedRoles && !allowedRoles.includes(staffRole)) {
    return <Navigate to="/select-place" replace />;
  }

  return <Outlet />;
};

export default RequireRole;
